import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap, throwError } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PaginationRequest } from "src/app/models/common.request";
import { IWard } from "./Iward";


@Injectable({ providedIn: 'root' })
export class WardService {

    private _ward: BehaviorSubject<IWard | null> = new BehaviorSubject<IWard | null>(null);
    private _wards: BehaviorSubject<IWard[]> = new BehaviorSubject<IWard[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get ward$(): Observable<IWard | null> {
        return this._ward.asObservable();
    }

    get wards$(): Observable<IWard[]> {
        return this._wards.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }

    getAllWards(ward: PaginationRequest): Observable<BaseRespone<{ pagination: PaginationResult; wardDetails: IWard[] }>> {
        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; wardDetails: IWard[] }>>(`${environment.baseURl}/Ward/list`, ward).pipe(
            tap((response) => {
                this._pagination.next(response.result.pagination);
                this._wards.next(response.result.wardDetails);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createWard(warddetails: IWard): Observable<BaseRespone<IWard>> {
        return this._httpClient.post<BaseRespone<IWard>>(`${environment.baseURl}/Ward`, warddetails)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newtype) => {
                    // Return the new
                    return newtype;
                })
            )
    }

    deleteWard(id: number): Observable<BaseRespone<boolean>> {
        return this.wards$.pipe(
            take(1),
            switchMap(ward =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/Ward/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const updated = ward.filter(item => item.id !== id);
                            this._wards.next(updated);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    updateWard(warddetails: IWard): Observable<BaseRespone<IWard>> {
        return this.wards$.pipe(
            take(1),
            switchMap(wards => this._httpClient.put<BaseRespone<IWard>>(`${environment.baseURl}/Ward`, warddetails).pipe(
                map((updated: BaseRespone<IWard>) => {
                    // Find the index of the updated product
                    const index = wards.findIndex(item => item.id === warddetails.id);

                    // Update the product
                    wards[index] = warddetails;

                    // Update the products
                    this._wards.next(wards);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

}